  (function () {
    "use strict";

    /* URL das racas e handle da colecao chegam por data-attribute do #pd —
       este arquivo e um asset estatico, sem Liquid. Atribuidos apos o guard. */
    var RACAS_URL = null;
    var COLECAO = "";

    var TAMANHOS = [
      { t: "EPP", rot: "até 3 kg",  min: 0,  max: 3   },
      { t: "PP",  rot: "3–5 kg",    min: 3,  max: 5   },
      { t: "P",   rot: "5–10 kg",   min: 5,  max: 10  },
      { t: "M",   rot: "10–17 kg",  min: 10, max: 17  },
      { t: "G",   rot: "17–24 kg",  min: 17, max: 24  },
      { t: "GG",  rot: "24–32 kg",  min: 24, max: 32  },
      { t: "EXG", rot: "32 kg+",    min: 32, max: 999 }
    ];
    var ORDEM = TAMANHOS.map(function (s) { return s.t; });

    /* As notas AVISAM — nenhuma muda o tamanho sugerido (ver avisoDeCorpo).
       Por isso a ação de cada uma é uma instrução para quem está com o
       cachorro na frente, não uma decisão tomada pelo site. */
    var NOTAS = {
      L: { txt: "peito largo", acao: "Se ficar justo nesse tamanho, o seguinte resolve." },
      D: { txt: "dorso longo", acao: "Confira o comprimento do dorso, não só o peso." },
      P: { txt: "muito pelo",  acao: "Meça por cima do pelo, na parte mais larga do peito." }
    };

    var CHAVE = "pacco.pet";
    var VALIDADE = 90 * 24 * 60 * 60 * 1000; /* filhote cresce */

    var pd  = document.getElementById("pd");
    var pdf = document.getElementById("pdf");
    if (!pd || !pdf) return;
    RACAS_URL = pd.getAttribute("data-racas");
    COLECAO   = pd.getAttribute("data-colecao") || "";

    /* ATENCAO: este snippet e renderizado ANTES de collection-product-grid.
       Procurar o <ul> aqui em cima devolve null e o componente morre calado —
       foi exatamente o que aconteceu no primeiro push. O grid so e resolvido
       dentro de iniciar(), depois do DOMContentLoaded. */
    var grid = null;

    var trilho = document.getElementById("pd-trilho");
    var folha  = pdf.querySelector(".pdf__folha");
    var fTit   = pdf.querySelector(".pdf__titulo");
    var fSub   = pdf.querySelector(".pdf__sub");
    var fCorpo = pdf.querySelector(".pdf__corpo");
    var fPe    = pdf.querySelector(".pdf__pé");

    var RACAS = [];
    var ESTOQUE = {};          /* handle -> { d:[tam], x:[tam] } */
    var ITENS = [];            /* { li, handle, ordem } */
    /* `so` nasce LIGADO por decisao do Lucas (20/08): ao escolher um tamanho a
       vitrine mostra so o que da para comprar. O toggle continua ali para quem
       quiser ver os esgotados, e o saldo oferece o atalho — e por ali que o
       avise-me (o sensor de demanda por tamanho) continua alcancavel. */
    var st = { tam: null, raca: null, peso: null, origem: null, so: true, aberto: false };
    /* marca que um atalho de peso esta sendo tocado, para o `change` do
       campo nao roubar o gesto (ver o handler de pointerdown) */
    var gestoAtalho = false;
    /* debounce da busca de raca; abre() e fecha() cancelam para o
       re-render orfao nao reescrever a lista com a folha ja saindo */
    var tid = null;

    /* Quem ja pediu aviso, por "handle|tamanho". O estado vivia so no no do DOM
       e limpaVitrine() apaga todos os .pd-avise a cada pintura: bastava esconder
       e revelar os esgotados para o botao voltar a "avise-me quando voltar",
       habilitado, e um segundo toque emitir o MESMO evento de novo — inflando
       por repeticao justamente o numero que serve de sensor de demanda.
       Fica no sessionStorage, nao no localStorage: a chave "pacco.pet" expira
       em 90 dias pensando em filhote que cresce, e pedido de reposicao nao
       pertence a esse relogio — mas um reload da pagina tambem nao pode zerar
       o registro, senao o mesmo dedo infla o sensor de demanda a cada F5. */
    var AVISADOS = {};
    var CHAVE_AVISADOS = "pacco.pet.avisados";
    try { AVISADOS = JSON.parse(sessionStorage.getItem(CHAVE_AVISADOS) || "{}") || {}; } catch (e) { AVISADOS = {}; }

    var aviva = pd.querySelector("[data-pd-aviva]");
    var tAviva = null;
    function anuncia(txt) {
      if (!aviva) return;
      /* num tick separado: trocar o texto no mesmo quadro em que a vitrine
         inteira muda faz o leitor de tela perder o anuncio */
      clearTimeout(tAviva);
      tAviva = setTimeout(function () { aviva.textContent = txt; }, 120);
    }

    /* ---------------------------------------------------------- utilidades */
    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }
    function kg(v) { return String(v).replace(".", ","); }
    function norma(s) {
      return String(s).toLowerCase().normalize("NFD")
        .replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]/g, "");
    }
    function faixa(t) {
      for (var i = 0; i < TAMANHOS.length; i++) if (TAMANHOS[i].t === t) return TAMANHOS[i];
      return null;
    }
    function porPeso(v) {
      for (var i = 0; i < TAMANHOS.length; i++) {
        if (v > TAMANHOS[i].min && v <= TAMANHOS[i].max) return TAMANHOS[i].t;
      }
      return v <= 3 ? "EPP" : "EXG";
    }
    function ev(nome, extra) {
      var p = { pd_colecao: COLECAO };
      for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: nome }, p));
      /* o GTM da loja roda dentro do sandbox de um custom pixel e não enxerga o
         dataLayer da vitrine — por isso o gtag direto, igual pacco-medicao. */
      if (typeof window.gtag === "function") {
        p.send_to = "G-Z7HTF6ZQLF";
        window.gtag("event", nome, p);
      }
    }

    /* ------------------------------------------------- busca perdoando erro */
    function dist(a, b) {
      if (a === b) return 0;
      if (Math.abs(a.length - b.length) > 2) return 9;
      var lin = [], i, j;
      for (j = 0; j <= b.length; j++) lin[j] = j;
      for (i = 1; i <= a.length; i++) {
        var ant = lin[0]; lin[0] = i;
        for (j = 1; j <= b.length; j++) {
          var tmp = lin[j];
          lin[j] = Math.min(lin[j] + 1, lin[j - 1] + 1,
                            ant + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
          ant = tmp;
        }
      }
      return lin[b.length];
    }
    function procura(txt) {
      var q = norma(txt);
      if (!q) return RACAS.slice();
      var g = [[], [], [], []];
      RACAS.forEach(function (r) {
        var nivel = -1;
        for (var i = 0; i < r.k.length; i++) {
          var k = r.k[i];
          if (k === q) { nivel = 0; break; }
          if (q.length >= 2 && k.indexOf(q) === 0) { if (nivel < 0 || nivel > 1) nivel = 1; }
          /* a chave dentro do que foi digitado: "labrador preto", "pitbull
             filhote", "shih tzu da minha mae". A cliente descreve o cachorro,
             não digita só o nome da raça — e a distância de edição nunca casa
             isso, porque o texto extra a explode. Mínimo de 4 letras para o
             "pit" de "pitbull" não casar meia lista. */
          else if (k.length >= 4 && q.indexOf(k) >= 0) { if (nivel < 0 || nivel > 1) nivel = 1; }
          else if (q.length >= 3 && k.indexOf(q) >= 0) { if (nivel < 0 || nivel > 2) nivel = 2; }
          else if (dist(k, q) <= (q.length <= 5 ? 1 : 2)) { if (nivel < 0) nivel = 3; }
        }
        if (nivel >= 0) g[nivel].push(r);
      });
      return g[0].concat(g[1], g[2], g[3]);
    }

    /* A nota de corpo AVISA, nunca decide.

       Antes ela subia um tamanho inteiro para "peito largo" e "muito pelo".
       Três razões para parar:

       1. O degrau não vale a mesma coisa em cada ponto da escala. PP→P são
          +5 kg de faixa; GG→EXG troca um teto de 32 kg por nenhum teto. Um
          Border de 28 kg virava EXG, e um Boxer de 28 kg iria junto.
       2. Pelo COMPRIME quando a roupa fecha; osso e músculo não. Tratar os
          dois com o mesmo degrau nunca fez sentido.
       3. Não temos as medidas de peito das peças — o item que segue aberto com
          a produção. Sem elas não há base para subir um tamanho inteiro por
          formato de corpo, e errar para cima também custa: roupa folgada em
          cão pequeno volta igual.

       O aviso continua, e o vizinho maior está a um toque nos chips "Prefere
       outro?" — quem decide passa a ser quem está olhando o cachorro.
       (Border Collie de 28 kg, apontado pelo Lucas em 21/08.) */
    function avisoDeCorpo(raca) {
      if (!raca || !raca.nota || !NOTAS[raca.nota]) return null;
      return esc(raca.n) + " tem " + NOTAS[raca.nota].txt + ". " + NOTAS[raca.nota].acao;
    }

    /* ------------------------------------------------------------- o motor */
    function decide(raca, peso) {
      var r = { tam: null, titulo: "", linhas: [], cuidado: null };

      if (peso != null && !isNaN(peso)) {
        var base = porPeso(peso);
        r.tam = base;
        r.titulo = raca ? raca.n + " de " + kg(peso) + " kg" : kg(peso) + " kg";

        if (raca && raca.kg) {
          if (peso < raca.kg[0] * 0.6 || peso > raca.kg[1] * 1.6) {
            r.cuidado = "Um " + raca.n + " costuma ter entre " + kg(raca.kg[0]) + " e " +
                        kg(raca.kg[1]) + " kg. Confere que são " + kg(peso) +
                        " kg? Se for filhote, o melhor é medir o peito.";
          }
          r.linhas.push(kg(peso) + " kg entra na faixa de <strong>" + esc(faixa(base).rot) + "</strong>.");
          var aviso = avisoDeCorpo(raca);
          if (aviso) r.linhas.push(aviso);
        } else {
          r.linhas.push(kg(peso) + " kg entra na faixa de <strong>" + esc(faixa(base).rot) + "</strong>.");
        }
        return r;
      }

      if (raca && raca.kg) {
        r.tam = raca.t;
        r.titulo = raca.n;
        r.linhas.push(esc(raca.n) + " costuma vestir <strong>" + esc(raca.t) + "</strong> (" +
                      esc(faixa(raca.t).rot) + ").");
        if (raca.tmin !== raca.tmax) {
          /* Enumerar a faixa inteira, não só as pontas. O Whippet (9-19 kg)
             recomendava M e avisava "cabem P e G" — deixando de fora justamente
             o tamanho que a própria folha estava sugerindo. */
          var iMin = ORDEM.indexOf(raca.tmin), iMax = ORDEM.indexOf(raca.tmax);
          var entre = (iMin >= 0 && iMax >= iMin)
            ? ORDEM.slice(iMin, iMax + 1)
            : [raca.tmin, raca.tmax];
          var lista = entre.length > 2
            ? entre.slice(0, -1).join(", ") + " e " + entre[entre.length - 1]
            : entre.join(" e ");
          r.cuidado = "A faixa da raça vai de " + kg(raca.kg[0]) + " a " + kg(raca.kg[1]) +
                      " kg — nesse intervalo cabem " + lista + ". O peso resolve em um toque.";
        }
        /* mesma função do ramo com peso — os dois caminhos passam a dizer a
           mesma coisa sobre o mesmo cachorro. Antes o ramo só-raça imprimia
           "costuma pedir um número acima" ao lado de um número que não tinha
           subido, e dois toques depois o mesmo Pug virava M. */
        var av = avisoDeCorpo(raca);
        if (av) r.linhas.push(av);
        return r;
      }
      return r;
    }

    /* ------------------------------------------------------------ persistência */
    function guarda() {
      try {
        localStorage.setItem(CHAVE, JSON.stringify({
          tam: st.tam, peso: st.peso, raca: st.raca ? st.raca.n : null,
          origem: st.origem, em: Date.now()
        }));
      } catch (e) {}
    }
    function recupera() {
      try {
        var v = JSON.parse(localStorage.getItem(CHAVE) || "null");
        if (!v || !v.tam) return;
        if (Date.now() - (v.em || 0) > VALIDADE) { localStorage.removeItem(CHAVE); return; }
        st.tam = v.tam; st.peso = v.peso; st.origem = v.origem;
        if (v.raca) {
          for (var i = 0; i < RACAS.length; i++) if (RACAS[i].n === v.raca) { st.raca = RACAS[i]; break; }
        }
      } catch (e) {}
    }

    /* ---------------------------------------------------------------- ícones */
    var I = {
      seta:   '<svg class="seta" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h13"/><path d="m12 5 7 7-7 7"/></svg>',
      busca:  '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
      regua:  '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="7" width="20" height="10" rx="2"/><path d="M6 7v3M10 7v4M14 7v3M18 7v4"/></svg>',
      alerta: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16.5v.01"/></svg>'
    };

    /* ------------------------------------------------------------- a folha */

    /* A saída da folha é um setTimeout de 240 ms. Solto, ele causava três
       coisas: reabrir dentro da janela deixava overflow:hidden no <html> sem
       folha na tela (coleção sem rolagem), o debounce órfão da busca reescrevia
       o corpo enquanto a folha deslizava, e o véu já invisível continuava
       comendo o toque seguinte. Guardar o handle e cancelar resolve os três. */
    var tFecha = null;
    var focoAnterior = null;

    /* O TECLADO DO IOS — a causa real do "a folha foi para o meio e depois
       sumiu para baixo" (Lucas, 21/08, aba anônima no iPhone).

       No iOS o layout viewport NÃO encolhe quando o teclado sobe. Uma folha
       ancorada em bottom:0 fica atrás do teclado, e o Safari ainda rola a
       página para tentar trazer o campo focado à vista, arrastando a folha
       junto. O tamanho da tela em CSS continua mentindo o tempo todo.

       A visualViewport é a única fonte que sabe o que está REALMENTE visível.
       Daqui saem duas medidas que o CSS usa: quanto o teclado cobre do fundo,
       e a altura útil que sobrou. */
    function ajustaTeclado() {
      var vv = window.visualViewport;
      if (!vv) return;

      /* o que sobrou embaixo: altura total menos o que se vê, menos o quanto o
         viewport visual já foi empurrado para cima */
      var coberto = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
      pdf.style.setProperty("--pd-teclado", coberto + "px");
      pdf.style.setProperty("--pd-vvh", Math.round(vv.height) + "px");
      pdf.classList.toggle("tem-teclado", coberto > 120);

      /* NÃO somar um transform de `offsetTop` aqui. Cheguei a escrever isso
         achando que faltava compensar o scroll do Safari, e o teste mostrou o
         contrário: o `offsetTop` JÁ está dentro do cálculo de `coberto` acima.
         Com janela de 656, área visível de 336 e scroll de 140, o `bottom` de
         180 põe a base da folha em 476 — exatamente o fundo do que se vê.
         O transform empurrava os mesmos 140 de novo e jogava a folha para
         fora. Uma compensação, não duas. */
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", ajustaTeclado);
      window.visualViewport.addEventListener("scroll", ajustaTeclado);
    }

    function focaFolha() {
      /* dentro do MESMO rAF que liga is-on: antes disso a folha é display:none
         e o focus() não pega. preventScroll é obrigatório — sem ele o navegador
         rola a página até a folha, que foi o pulo que o Lucas viu ao digitar. */
      try { folha.focus({ preventScroll: true }); } catch (e) { folha.focus(); }
    }

    var tAbriu = 0;

    function abre(tit, sub, corpo, pe) {
      clearTimeout(tFecha);
      clearTimeout(tid);            /* debounce da busca não sobrevive à troca de tela */
      tAbriu = performance.now();   /* B3: janela anti-duplo-clique do véu */
      gestoAtalho = false;          /* B2: troca de tela desarma o gesto */

      /* guarda o gatilho só na PRIMEIRA abertura — trocar de tela dentro da
         folha não pode sobrescrever o botão a que devemos voltar */
      if (!st.aberto) focoAnterior = document.activeElement;


      fTit.textContent = tit;
      fSub.innerHTML = sub || "";
      fSub.style.display = sub ? "" : "none";
      fCorpo.innerHTML = corpo;
      fPe.innerHTML = pe || "";
      fPe.style.display = pe ? "" : "none";
      pdf.hidden = false;
      st.aberto = true;
      ajustaTeclado();          /* mede antes de mostrar, para não abrir torta */
      requestAnimationFrame(function () {
        pdf.classList.add("is-on", "is-vis");
        focaFolha();
      });
      document.documentElement.style.overflow = "hidden";
      fCorpo.scrollTop = 0;
    }
    function fecha() {
      clearTimeout(tFecha);
      clearTimeout(tid);
      gestoAtalho = false;          /* B2: fechar desarma o gesto */
      pdf.classList.remove("is-vis");
      st.aberto = false;
      document.documentElement.style.overflow = "";
      pdf.classList.remove("tem-teclado");
      pdf.style.removeProperty("--pd-teclado");
      tFecha = setTimeout(function () { pdf.classList.remove("is-on"); pdf.hidden = true; }, 240);

      /* devolve o foco a quem abriu, se ele ainda existir no documento — o
         re-render do trilho pode ter trocado o botão por outro nó */
      if (focoAnterior && document.contains(focoAnterior)) {
        try { focoAnterior.focus({ preventScroll: true }); } catch (e) { focoAnterior.focus(); }
      }
      focoAnterior = null;
    }

    function telaRaca(filtro) {
      /* O campo fica FORA do que é re-renderizado. Antes, cada tecla refazia o
         innerHTML inteiro e devolvia o foco com focus() — e focar um elemento
         recém-criado faz o navegador rolar até ele: era o pulo da folha para o
         meio da tela que o Lucas viu, mais o teclado do celular piscando
         porque o campo em foco era destruído. Agora só a lista troca. */
      return '<div class="pdf__busca">' + I.busca +
             '<input type="search" id="pd-q" placeholder="digite a raça — pode escrever errado" ' +
             'autocomplete="off" autocorrect="off" spellcheck="false" ' +
             'aria-label="Buscar raça" value="' + esc(filtro || "") + '"></div>' +
             '<div id="pd-lista">' + listaRacas(filtro) + "</div>";
    }

    function listaRacas(filtro) {
      var achadas = procura(filtro || "");
      var srd = RACAS[0];
      var resto = achadas.filter(function (r) { return r !== srd; });
      var achouSrd = achadas.indexOf(srd) >= 0;
      var mostraSrd = !filtro || achouSrd || !resto.length;
      var mostraVazio = !resto.length && !achouSrd;
      var h = "";

      if (mostraSrd) {
        h += '<button type="button" class="pdf__srd" data-pd-raca="0">' +
               '<span class="pt"><b>SRD — vira-lata</b>' +
               '<small>O cachorro mais amado do Brasil. Com ele a gente vai pelo peso, que é o mais certeiro.</small></span>' +
               I.seta +
             '</button>';
      }
      if (mostraVazio) {
        /* U1: o beco da busca ganha uma porta de verdade — o texto mandava
           "usar o peso" sem dar onde tocar. O cartão SRD segue logo acima. */
        h += '<p class="pdf__vazio">Não achei essa raça por aqui. O peso resolve para qualquer cachorro:</p>' +
             '<button type="button" class="pdf__bt pdf__bt--leve pdf__vazioBt" data-pd-abrir="peso">Informar o peso</button>';
      } else if (resto.length) {
        h += '<div class="pdf__racas">' + resto.map(function (r) {
          return '<button type="button" class="pdf__raca" data-pd-raca="' + RACAS.indexOf(r) + '">' +
                 esc(r.n) + (r.t ? ' <em>· ' + esc(r.t) + '</em>' : "") + "</button>";
        }).join("") + "</div>";
      }
      return h;
    }

    function telaPeso() {
      /* U5: o atalho diz aonde leva ("12 kg · M") e a régua embaixo mostra o
         mapa inteiro peso→tamanho, acendendo a faixa enquanto a cliente
         digita — a conta deixa de ser caixa-preta. aria-hidden na régua: o
         veredito falado já existe; a régua é reforço visual, não conteúdo. */
      var atalhos = [2, 4, 7, 12, 20, 28, 40];
      return '<div class="pdf__atalhos">' + atalhos.map(function (v) {
               return '<button type="button" class="pdf__atalho" data-pd-kg="' + v + '">' + v +
                      ' kg <em>· ' + porPeso(v) + "</em></button>";
             }).join("") + "</div>" +
             '<div class="pdf__campoPeso"><input type="number" id="pd-kg" inputmode="decimal" ' +
             'min="0.5" max="120" step="0.5" placeholder="0,0" ' +
             /* o leitor de tela anunciava só "0,0, campo numérico" — nem peso,
                nem quilo. O "kg" ao lado é decorativo, então sai da árvore. */
             'aria-label="Peso do seu cachorro em quilos">' +
             '<span class="un" aria-hidden="true">kg</span></div>' +
             '<div class="pdf__regua" aria-hidden="true">' + TAMANHOS.map(function (s) {
               return '<span class="pdf__reguaItem" data-pd-regua="' + s.t + '"><b>' + s.t + "</b> " + esc(s.rot) + "</span>";
             }).join("") + "</div>";
    }

    /* U5: quem não sabe o peso não pode ficar preso na tela do peso.
       NÃO entra na chamada vinda do SRD — lá seria um círculo. */
    function pePeso() {
      return '<div class="pdf__acoes">' +
             '<button type="button" class="pdf__bt pdf__bt--leve" data-pd-abrir="raca">Não sei o peso — buscar pela raça</button>' +
             "</div>";
    }

    function telaVeredito() {
      var d = decide(st.raca, st.peso);
      if (!d.tam) return null;
      var f = faixa(d.tam);
      st.pendente = d.tam;

      /* O proprio tamanho e o botao: a cliente toca no "P" e ja cai na vitrine
         filtrada, sem precisar procurar o CTA la embaixo (Lucas, 20/08). */
      var h = '<button type="button" class="pdv__topo" data-pd-usar>' +
                '<span class="pdv__letra">' + esc(d.tam) + "</span>" +
                '<span class="pdv__dizer"><h4>' + esc(d.titulo) + "</h4>" +
                  "<p>" + esc(f.rot) + "</p>" +
                  '<span class="pdv__toque">toque para ver os ' + esc(d.tam) + "</span>" +
                "</span>" +
              "</button>";
      h += '<div class="pdv__linhas">' + d.linhas.map(function (l) { return "<p>" + l + "</p>"; }).join("") + "</div>";

      /* vizinhos imediatos: cachorro entre dois tamanhos e a regra, nao a
         excecao — 77% das racas cruzam faixa. Um toque resolve. */
      var iAtual = ORDEM.indexOf(d.tam);
      var vz = [];
      if (iAtual > 0) vz.push(ORDEM[iAtual - 1]);
      if (iAtual < ORDEM.length - 1) vz.push(ORDEM[iAtual + 1]);
      if (vz.length) {
        h += '<div class="pdv__vizinhos"><span class="rot">Prefere outro?</span>' +
             vz.map(function (t) {
               return '<button type="button" class="pdv__vz" data-pd-usar-outro="' + t + '">' +
                      t + ' <span class="kg">' + faixa(t).rot + "</span></button>";
             }).join("") + "</div>";
      }
      if (d.cuidado) h += '<div class="pdv__cuidado">' + I.alerta + "<span>" + esc(d.cuidado) + "</span></div>";
      /* A tabela de medidas saiu daqui (Lucas, 20/08): as colunas em cm ainda nao
         existem, entao ela abria vazia. O lugar dela e a pagina do produto.
         Fica so a recomendacao, que e o que importa nesta altura da decisao. */
      h += '<p class="pdv__nota">A medida do peito é o que decide o caimento. ' +
           "Confira na página do produto antes de fechar.</p>";
      return h;
    }

    function peVeredito() {
      var precisaPeso = st.peso == null;
      return '<div class="pdf__acoes">' +
               '<button type="button" class="pdf__bt pdf__bt--forte" data-pd-usar>Ver os ' + esc(st.pendente) + "</button>" +
               (precisaPeso
                 ? '<button type="button" class="pdf__bt pdf__bt--leve" data-pd-abrir="peso">Informar o peso</button>'
                 : '<button type="button" class="pdf__bt pdf__bt--leve" data-pd-abrir="raca">Trocar</button>') +
             "</div>";
    }

    /* --------------------------------------------------------- estoque real */
    /* Os DOIS fetches disparam num mini <script> inline no snippet, ANTES
       deste asset deferido carregar — sem isso, o defer devolveria o inicio
       da rede para depois do DOMContentLoaded e custaria ~500ms de vitrine.
       O fallback refaz os fetches caso o kickoff nao exista (asset servido
       fora do snippet, edge de cache). */
    function dados() {
      if (window.__pdDados && window.__pdDados.estoque) return window.__pdDados;
      return {
        estoque: fetch("/collections/" + COLECAO + "/products.json?limit=250", { credentials: "same-origin" })
          .then(function (r) { if (!r.ok) throw new Error("http " + r.status); return r.json(); }),
        racas: fetch(RACAS_URL).then(function (r) { return r.json(); })
      };
    }

    function constroiEstoque(j) {
      ESTOQUE = {};   /* o cache do P3 pode ter handle que já saiu da coleção */
          (j.products || []).forEach(function (p) {
            var d = [], x = [], precos = {}, ids = {};
            (p.variants || []).forEach(function (v) {
              var t = String(v.option1 || "").trim().toUpperCase();
              if (ORDEM.indexOf(t) < 0) return;
              /* o Suéter Fauna Retro tem a grade duplicada (12 variantes):
                 colapsa por tamanho — disponível se QUALQUER variante daquele
                 tamanho estiver disponível. */
              if (v.available) { if (d.indexOf(t) < 0) d.push(t); }
              else if (x.indexOf(t) < 0) x.push(t);

              /* preço do tamanho. Com a grade duplicada, a variante DISPONÍVEL
                 manda — é o preço que a cliente vai pagar de verdade.
                 U3: o id anda JUNTO do preço vencedor, no mesmo branch — o
                 ?variant= do card abre a PDP na variante do preço mostrado,
                 nunca numa prima da grade duplicada. */
              var novo = { p: parseFloat(v.price), c: v.compare_at_price ? parseFloat(v.compare_at_price) : null };
              if (!isNaN(novo.p) && (!precos[t] || v.available)) { precos[t] = novo; ids[t] = v.id; }
            });
            /* Nem tudo numa coleção de roupa tem grade de letra. O Cobertor
               Fleece Soft Touch vende por COR (Verde/Violeta/Azul) e estava
               disponível, mas caía no balde dos "sem M" e sumia da vitrine —
               revelado, aparecia com selo vermelho e "avise-me" sobre produto
               em estoque. Estes ficam neutros: visíveis, sem selo, sem repreço,
               e fora das duas contagens. */
            ESTOQUE[p.handle] = {
              d: d, x: x, precos: precos, ids: ids,
              semGrade: d.length === 0 && x.length === 0
            };
          });
    }

    /* Mapeia SÓ os <li> que ainda não conhecemos, anexando ao fim de ITENS.

       Por que incremental e não `ITENS = []` seguido de varredura: a ordem é
       lida do DOM, e depois da primeira pintura o DOM já está reordenado por
       nós. Reconstruir do zero congelaria a ordem embaralhada como se fosse a
       ordem original da coleção, e não haveria mais volta ao estado "Todos".
       Por isso `ordem` continua crescendo a partir do que já existe. */
    function mapeiaNovos() {
      var lis = grid.querySelectorAll("li.product");
      var achou = 0;
      for (var i = 0; i < lis.length; i++) {
        if (lis[i].__pdHandle) continue;
        var a = lis[i].querySelector('a[href*="/products/"]');
        if (!a) continue;
        var m = a.getAttribute("href").match(/\/products\/([^?#\/]+)/);
        if (!m) continue;
        /* o handle fica no próprio <li> para pintaPreco() não depender de
           procurar o item na lista a cada card */
        lis[i].__pdHandle = m[1];
        ITENS.push({ li: lis[i], handle: m[1], ordem: ITENS.length });
        achou++;
      }
      return achou;
    }

    /* O "Ver mais" do tema anexa <li> novos dentro do mesmo <ul> sem avisar
       ninguém (assets/theme.js, currentProductListing.append). Em /inverno são
       42 produtos e a página abre com 20: os outros 22 chegavam sem selo, com
       preço genérico e sem checagem de tamanho, e no toque seguinte subiam para
       o topo. O observer devolve esses cards ao mesmo tratamento dos demais. */
    /* B6: enquanto o estoque nao chegou, os chips existem mas nao filtram —
       clicar antes dos dados nao pode pintar uma vitrine vazia. */
    var pronto = false;

    var repintando = false;
    function vigiaGrid() {
      if (!window.MutationObserver) return;
      /* B5: o sort/filtro do tema (collection-filters-form.js) troca o
         innerHTML de "#CollectionProductGrid .collection" — o UL inteiro morre
         e renasce, levando selos, preços e o listener do interesse junto.
         #CollectionProductGrid é o único nó que sobrevive à troca, então é
         nele que moram o observer e a delegação de cliques (ver iniciar). */
      var casa = document.getElementById("CollectionProductGrid") || grid;
      new MutationObserver(function () {
        if (repintando) return;            /* a própria pintura move nós */
        if (!grid || !grid.isConnected) {
          var novo = document.getElementById("main-collection-product-grid");
          if (!novo) return;               /* meio da troca; a próxima mutação resolve */
          grid = novo;
          ITENS = [];                      /* os <li> antigos morreram com o UL */
        }
        if (!mapeiaNovos()) return;
        repintando = true;
        requestAnimationFrame(function () {
          try { pintaVitrine(); } finally { repintando = false; }
        });
      }).observe(casa, { childList: true, subtree: true });
    }

    /* ------------------------------------------------------------- vitrine */
    function limpaVitrine() {
      grid.querySelectorAll(".pd-selo, .pd-avise").forEach(function (n) { n.remove(); });
      var corte = grid.querySelector("li.pd-corte");
      if (corte) corte.remove();
      ITENS.forEach(function (it) {
        it.li.classList.remove("pd-fora", "pd-oculto");
        devolvePreco(it.li);
        devolveLinks(it.li);
      });
    }

    /* U2: o vizinho mais próximo do tamanho esgotado que tenha ao menos um
       modelo disponível NESTA coleção. Preferindo o maior a cada distância:
       roupa apertada não fecha; folgada ainda veste. */
    function vizinhoComEstoque(tam) {
      var i = ORDEM.indexOf(tam);
      if (i < 0) return null;
      var passos = [1, -1, 2, -2, 3, -3, 4, -4, 5, -5, 6, -6];
      for (var p = 0; p < passos.length; p++) {
        var t = ORDEM[i + passos[p]];
        if (!t) continue;
        for (var h in ESTOQUE) {
          if (Object.prototype.hasOwnProperty.call(ESTOQUE, h) &&
              ESTOQUE[h].d.indexOf(t) >= 0) return t;
        }
      }
      return null;
    }

    /* U2: pacco_zero_resultado conta por tamanho, não por repintura — sort e
       "ver mais" repintam a mesma vitrine e inflariam o sensor. */
    var zeroAvisado = null;

    function pintaVitrine() {
      limpaVitrine();
      /* P2: um appendChild por <li> forçava o layout a cada movimento — 36ms
         por clique de chip no desktop, pior no celular. A nova ordem inteira
         é montada num DocumentFragment (nós destacados, zero layout) e entra
         no grid numa inserção só. */
      var frag = document.createDocumentFragment();
      if (!st.tam) {
        ITENS.slice().sort(function (a, b) { return a.ordem - b.ordem; })
          .forEach(function (it) { frag.appendChild(it.li); });
        grid.appendChild(frag);
        return;
      }

      /* Três baldes, não dois. O ternário binário jogava em "fora" tudo que não
         tinha o tamanho — inclusive quem não tem grade de letra nenhuma, e quem
         o JSON não trouxe. Nenhum dos dois é "esgotado no tamanho M". */
      var serve = [], fora = [], neutros = [];
      ITENS.forEach(function (it) {
        var e = ESTOQUE[it.handle];
        if (!e || e.semGrade) { neutros.push(it); return; }
        (e.d.indexOf(st.tam) >= 0 ? serve : fora).push(it);
      });

      /* U2: zero resultado não pode ser beco. Sem nada que sirva, os esgotados
         aparecem MESMO com o "só o que serve" ligado — sem persistir nada:
         st.so continua true, só esta pintura abre a mão. */
      var soEfetivo = st.so && serve.length > 0;

      serve.forEach(function (it) {
        frag.appendChild(it.li);
        selo(it.li, st.tam + " disponível", false);
        pintaPreco(it.li, st.tam);
        pintaLinks(it.li, st.tam);
      });

      /* neutros entram logo depois dos que servem, na ordem original da coleção,
         intocados — o tamanho escolhido simplesmente não se aplica a eles */
      neutros.sort(function (a, b) { return a.ordem - b.ordem; })
             .forEach(function (it) { frag.appendChild(it.li); });

      if (fora.length && !soEfetivo) {
        var corte = document.createElement("li");
        corte.className = "pd-corte";
        var corteTxt, corteChip = "";
        if (!serve.length) {
          /* U2: a mensagem do zero oferece a saída — o vizinho com estoque */
          var vz = vizinhoComEstoque(st.tam);
          corteTxt = "<strong>O " + esc(st.tam) + " esgotou nesta coleção.</strong> " +
            "Estes modelos voltam — toque em <strong>tenho interesse</strong>" +
            (vz ? " — ou veja o " + esc(vz) + " (" + esc(faixa(vz).rot) + "):" : ".");
          if (vz) {
            corteChip = '<button type="button" class="pd-corte__vz" data-pd-vizinho="' +
                        esc(vz) + '">Ver os ' + esc(vz) + "</button>";
          }
        } else {
          corteTxt = "<strong>Sem o tamanho " + esc(st.tam) + " no momento</strong> — " + fora.length +
            " " + (fora.length === 1 ? "modelo" : "modelos") +
            ". Toque em <strong>tenho interesse</strong> — isso ajuda a gente a repor esse tamanho mais rápido.";
        }
        corte.innerHTML = '<div class="pd-corte__linha"><span class="pd-corte__txt">' +
          corteTxt + "</span>" + corteChip + "</div>";
        frag.appendChild(corte);
      }

      fora.forEach(function (it) {
        frag.appendChild(it.li);
        it.li.classList.add("pd-fora");
        if (soEfetivo) { it.li.classList.add("pd-oculto"); return; }
        selo(it.li, st.tam + " esgotado", true);
        pintaPreco(it.li, st.tam);
        pintaLinks(it.li, st.tam);
        var alvo = it.li.querySelector(".card-product-info, .card-information, .product-item-info, .card__content") || it.li;
        var b = document.createElement("button");
        b.type = "button";
        b.className = "pd-avise";
        b.setAttribute("data-pd-avise", it.handle);
        if (AVISADOS[it.handle + "|" + st.tam]) {
          b.textContent = "interesse registrado";
          b.disabled = true;
        } else {
          b.textContent = "tenho interesse nesse tamanho";
        }
        alvo.appendChild(b);
      });

      grid.appendChild(frag);

      var el = pd.querySelector("[data-pd-saldo]");
      if (el) {
        /* a coleção pagina — dizer "20 modelos" sem o "nesta página" seria uma
           contagem errada na cara da cliente. E o aviso tem que SUMIR quando o
           "Ver mais" já trouxe todo mundo, senão passa a mentir ao contrário.

           Comparar ITENS com ESTOQUE, e não procurar o botão de paginação: o
           tema mantém o botão no DOM e só troca o texto para "Não há mais
           produto", então qualquer seletor de botão diz "ainda falta" para
           sempre. ESTOQUE tem a coleção inteira (limit 250) e ITENS tem o que
           está no DOM — a diferença é exatamente o que falta carregar. */
        var maisPag = Object.keys(ESTOQUE).length > ITENS.length;
        var cauda = "";
        /* no zero o toggle sai: os esgotados já estão à mostra por soEfetivo,
           e um "esconder" que não esconde nada só mente */
        if (fora.length && serve.length) {
          cauda = ' · <button type="button" class="pd__verFora" data-pd-ver-fora>' +
                  (st.so ? "ver " + fora.length + " sem " + esc(st.tam)
                         : "esconder os " + fora.length + " sem " + esc(st.tam)) +
                  "</button>";
        }
        el.innerHTML = "<strong>" + serve.length + "</strong> " +
          (serve.length === 1 ? "modelo" : "modelos") + " com " + esc(st.tam) +
          cauda + (maisPag ? " <span>(nesta página)</span>" : "");
      }
      if (serve.length) {
        zeroAvisado = null;
        anuncia(serve.length + (serve.length === 1 ? " modelo disponível" : " modelos disponíveis") +
                " no tamanho " + st.tam + (fora.length ? ". " + fora.length + " sem esse tamanho." : "."));
      } else {
        anuncia("Nenhum modelo disponível no tamanho " + st.tam +
                " no momento. Mostrando os esgotados, que voltam ao estoque.");
        if (zeroAvisado !== st.tam) {
          zeroAvisado = st.tam;
          ev("pacco_zero_resultado", { pd_tamanho: st.tam });
        }
      }
      ev("pacco_vitrine_ordenada", { pd_tamanho: st.tam, pd_serve: serve.length, pd_fora: fora.length });
    }

    /* ---- preço do tamanho escolhido ---------------------------------------
       Nesta loja os 34 produtos têm preço POR TAMANHO, e a diferença é grande:
       o Colete Carneirinho vai de R$ 97,43 (EPP) a R$ 164,93 (EXG). Sem
       tamanho escolhido o tema mostra "a partir de R$ 97,43" — então quem tem
       cão grande só descobre os R$ 164,93 dentro da PDP. Escolhido o tamanho,
       o card passa a mostrar o preço que ela vai pagar de fato. */
    var moeda = null;
    try {
      moeda = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
    } catch (e) { moeda = null; }

    function dinheiro(v) {
      if (moeda) return moeda.format(v);
      return "R$ " + v.toFixed(2).replace(".", ",");
    }

    function pintaPreco(li, tam) {
      var caixa = li.querySelector(".card-price");
      if (!caixa) return;

      /* guarda o original UMA vez: é ele que volta quando a cliente limpa */
      if (caixa.dataset.pdOriginal === undefined) caixa.dataset.pdOriginal = caixa.innerHTML;

      var e = ESTOQUE[li.__pdHandle];
      var pr = e && e.precos ? e.precos[tam] : null;
      if (!pr) { caixa.innerHTML = caixa.dataset.pdOriginal; return; }

      var h = '<span class="pd-preco">';
      if (pr.c && pr.c > pr.p) h += '<span class="pd-preco__de">' + dinheiro(pr.c) + "</span>";
      h += '<span class="pd-preco__por">' + dinheiro(pr.p) + "</span></span>";
      caixa.innerHTML = h;
    }

    function devolvePreco(li) {
      var caixa = li.querySelector(".card-price");
      if (caixa && caixa.dataset.pdOriginal !== undefined) {
        caixa.innerHTML = caixa.dataset.pdOriginal;
      }
    }

    /* U3: o tamanho escolhido viaja para a PDP. Preço no card e variante do
       link saem do MESMO id (ids[t], guardado junto do preço vencedor): a
       cliente vê R$ 164,93 no card e a PDP abre no EXG de R$ 164,93 — não na
       menor variante com "a partir de". No card esgotado, o link leva à
       variante esgotada do tamanho: coerente com quem vai registrar interesse. */
    function pintaLinks(li, tam) {
      var e = ESTOQUE[li.__pdHandle];
      var id = e && e.ids ? e.ids[tam] : null;
      if (!id) return;
      var as = li.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < as.length; i++) {
        var a = as[i];
        /* controles do tema que moram dentro do card mas não são "abrir o
           produto" (padrão do próprio theme.js) */
        if (a.closest(".single-action, .number-showmore, .vendor-text")) continue;
        if (a.dataset.pdHref === undefined) a.dataset.pdHref = a.getAttribute("href");
        var h = a.dataset.pdHref;
        a.setAttribute("href", h + (h.indexOf("?") >= 0 ? "&" : "?") + "variant=" + id);
      }
    }
    function devolveLinks(li) {
      var as = li.querySelectorAll("a[data-pd-href]");
      for (var i = 0; i < as.length; i++) as[i].setAttribute("href", as[i].dataset.pdHref);
    }

    function selo(li, txt, fora) {
      var s = document.createElement("span");
      s.className = "pd-selo" + (fora ? " pd-selo--fora" : "");
      s.textContent = txt;
      /* .card-media e o retangulo da foto. Ancorar ali (e nao no card inteiro)
         mantem o selo em cima da imagem, longe do badge PROMOCAO do tema, que
         mora no canto superior esquerdo.

         ATENCAO: querySelector com lista de seletores devolve o primeiro em
         ordem de DOCUMENTO, nao na ordem em que os seletores foram escritos —
         .product-item envolve .card-media, entao a lista unica ancorava o selo
         no rodape do card inteiro. Por isso a busca aqui e em cascata. */
      var host = null;
      var alvos = [".card-media", ".card-product", ".card", ".product-item"];
      for (var i = 0; i < alvos.length && !host; i++) host = li.querySelector(alvos[i]);
      if (!host) host = li;
      /* position:relative vem de regra CSS estática (pacco-descobridor.css).
         O getComputedStyle que morava aqui forçava um reflow POR CARD a cada
         pintura — e devolve vazio em nó destacado, o que quebraria a montagem
         em DocumentFragment logo abaixo. */
      host.appendChild(s);
    }

    /* --------------------------------------------------------------- barra */
    function pintaBarra() {
      trilho.innerHTML =
        '<button type="button" class="pd__tam pd__tam--todos" data-pd-todos aria-pressed="' +
        (!st.tam) + '">Todos <span class="kg">os tamanhos</span></button>' +
        TAMANHOS.map(function (s) {
          return '<button type="button" class="pd__tam" data-pd-tam="' + s.t + '" aria-pressed="' +
                 (st.tam === s.t) + '">' + s.t + ' <span class="kg">' + s.rot + "</span></button>";
        }).join("");

      pd.classList.toggle("is-on", !!st.tam);
      if (st.tam) {
        var f = faixa(st.tam);
        pd.querySelector("[data-pd-letra]").textContent = st.tam;
        pd.querySelector("[data-pd-faixa]").textContent = f.rot;
        var o = "";
        if (st.raca && st.peso != null) o = st.raca.n + " · " + kg(st.peso) + " kg";
        else if (st.raca) o = st.raca.n;
        else if (st.peso != null) o = kg(st.peso) + " kg";
        pd.querySelector("[data-pd-origem]").textContent = o;

        var ativo = trilho.querySelector('[aria-pressed="true"]');
        if (ativo && ativo.scrollIntoView) ativo.scrollIntoView({ block: "nearest", inline: "center" });
      }
      requestAnimationFrame(marcaRolagem);
    }

    /* volta ao estado de escolha: as portas e o trilho reaparecem, a vitrine
       destrava. Usado pelo "trocar", pelo chip "Todos os tamanhos" e por
       desmarcar o chip aceso — este último duplicava o corpo aqui embaixo e
       esquecia o evento, então a terceira via de desistência não aparecia na
       medição. Numa loja onde a compra não é mensurável, a micro-conversão é
       tudo que existe. */
    function volta(via) {
      st.tam = null; st.raca = null; st.peso = null; st.origem = null;
      guarda();
      pintaBarra();
      pintaVitrine();
      anuncia("Mostrando todos os tamanhos.");
      ev("pacco_tamanho_limpo", { pd_via: via || null });
    }

    /* No celular o trilho corta no M e nada dizia que dava para rolar. Estas
       classes acendem o degrade e a seta nas pontas certas, e somem quando a
       rolagem chega ao fim — indicador que mente e pior que indicador nenhum. */
    function marcaRolagem() {
      var pista = pd.querySelector(".pd__pista");
      if (!pista) return;
      var sobra = trilho.scrollWidth - trilho.clientWidth;
      var x = trilho.scrollLeft;
      pista.classList.toggle("tem-dir", sobra > 4 && x < sobra - 4);
      pista.classList.toggle("tem-esq", x > 4);
    }

    function aplica(tam, origem) {
      st.tam = tam;
      st.origem = origem;
      guarda();
      pintaBarra();
      pintaVitrine();
      ev("pacco_tamanho_definido", {
        pd_tamanho: tam, pd_origem: origem,
        pd_raca: st.raca ? st.raca.n : null, pd_peso: st.peso
      });
    }

    /* -------------------------------------------------------------- eventos */
    trilho.addEventListener("scroll", marcaRolagem, { passive: true });
    window.addEventListener("resize", marcaRolagem);

    pd.addEventListener("click", function (e) {
      if (!e.target.closest("[data-pd-mais]")) return;
      trilho.scrollBy({ left: Math.round(trilho.clientWidth * 0.7), behavior: "smooth" });
    });

    trilho.addEventListener("click", function (e) {
      if (!pronto) return;               /* B6: sem estoque, chip e inerte */
      if (e.target.closest("[data-pd-todos]")) { volta("todos"); return; }
      var b = e.target.closest("[data-pd-tam]");
      if (!b) return;
      var t = b.getAttribute("data-pd-tam");
      if (st.tam === t) { volta("chip"); return; }
      st.raca = null; st.peso = null;
      aplica(t, "chip");
    });

    pd.addEventListener("click", function (e) {
      if (e.target.closest("[data-pd-trocar]")) { volta("trocar"); return; }
      var ab = e.target.closest("[data-pd-abrir]");
      if (ab) {
        var qual = ab.getAttribute("data-pd-abrir");
        if (qual === "raca") {
          abre("Qual a raça do seu cachorro?", "A raça dá o ponto de partida. O peso é que fecha.", telaRaca(""), "");
          ev("pacco_porta_abriu", { pd_porta: "raca" });
        } else {
          abre("Quanto pesa o seu cachorro?",
               st.raca ? esc(st.raca.n) + " — não precisa ser exato, a faixa já resolve."
                       : "Não precisa ser exato. A faixa já resolve.",
               telaPeso(), pePeso());
          ev("pacco_porta_abriu", { pd_porta: "peso" });
        }
      }
    });

    pd.addEventListener("click", function (e) {
      if (!e.target.closest("[data-pd-ver-fora]")) return;
      st.so = !st.so;
      pintaVitrine();
      ev("pacco_so_serve", { pd_ligado: st.so, pd_via: "saldo" });
    });

    /* Busca: troca SÓ a lista. O campo não é recriado, então não há focus() a
       devolver, nem cursor a reposicionar, nem rolagem disparada, nem teclado
       piscando no celular — e não reconstruímos 71 botões a cada tecla. */
    /* U5: a régua acende a faixa do que está sendo digitado — em tempo real,
       parse igual ao confirmaPeso (vírgula vira ponto). NÃO acende no toque
       do atalho: o atalho navega na hora, ninguém veria. */
    pdf.addEventListener("input", function (e) {
      var c = e.target.closest("#pd-kg");
      if (!c) return;
      var regua = fCorpo.querySelector(".pdf__regua");
      if (!regua) return;
      var v = parseFloat(String(c.value).replace(",", "."));
      var t = (!isNaN(v) && v > 0) ? porPeso(v) : null;
      var ns = regua.querySelectorAll("[data-pd-regua]");
      for (var i = 0; i < ns.length; i++) {
        ns[i].classList.toggle("is-on", ns[i].getAttribute("data-pd-regua") === t);
      }
    });

    pdf.addEventListener("input", function (e) {
      var q = e.target.closest("#pd-q");
      if (!q) return;
      clearTimeout(tid);
      var v = q.value;
      tid = setTimeout(function () {
        var caixa = document.getElementById("pd-lista");
        if (!caixa) return;
        caixa.innerHTML = listaRacas(v);
        if (v && !caixa.querySelector(".pdf__raca") && !caixa.querySelector(".pdf__srd")) {
          ev("pacco_raca_nao_achou", { pd_texto: v.slice(0, 40) });
        }
      }, 110);
    });

    pdf.addEventListener("click", function (e) {
      /* B2: o pointerdown num atalho arma gestoAtalho; se o dedo soltar FORA
         do botão, o click nunca chega ao ramo do atalho e a bandeira ficava
         armada para sempre — o próximo change do campo de peso era engolido e
         o "concluído" do iOS não fazia nada. Qualquer clique na folha desarma;
         o ramo do atalho rearma o próprio fluxo logo abaixo. */
      gestoAtalho = false;
      if (e.target.closest("[data-pd-fechar]")) {
        /* B3: duplo-clique na porta — o segundo clique aterrissa no véu que
           acabou de abrir e fechava a folha no mesmo gesto. O véu ignora
           cliques nos primeiros 350 ms; X e Escape fecham sempre. */
        var eVeu = e.target.classList && e.target.classList.contains("pdf__véu");
        if (eVeu && (performance.now() - tAbriu) < 350) return;
        fecha(); return;
      }

      var r = e.target.closest("[data-pd-raca]");
      if (r) {
        st.raca = RACAS[parseInt(r.getAttribute("data-pd-raca"), 10)];
        st.peso = null;
        if (!st.raca.kg) { /* SRD vai direto ao peso */
          abre("Quanto pesa o seu cachorro?", "Com vira-lata o peso é o caminho certo.", telaPeso(), "");
          ev("pacco_porta_abriu", { pd_porta: "srd_peso" });
          return;
        }
        if (st.raca.tmin !== st.raca.tmax) ev("pacco_raca_ambigua", { pd_raca: st.raca.n });
        abre("O tamanho do seu cachorro", "", telaVeredito(), peVeredito());
        return;
      }

      var k = e.target.closest("[data-pd-kg]");
      if (k) {
        gestoAtalho = false;            /* o gesto terminou aqui */
        st.peso = parseFloat(k.getAttribute("data-pd-kg"));
        abre("O tamanho do seu cachorro", "", telaVeredito(), peVeredito());
        return;
      }

      var ab2 = e.target.closest("[data-pd-abrir]");
      if (ab2) {
        if (ab2.getAttribute("data-pd-abrir") === "peso") {
          abre("Quanto pesa o seu cachorro?",
               st.raca ? esc(st.raca.n) + " — não precisa ser exato." : "Não precisa ser exato.",
               telaPeso(), pePeso());
        } else {
          st.peso = null;
          abre("Qual a raça do seu cachorro?", "A raça dá o ponto de partida. O peso é que fecha.", telaRaca(""), "");
        }
        return;
      }

      var outro = e.target.closest("[data-pd-usar-outro]");
      if (outro) {
        st.pendente = outro.getAttribute("data-pd-usar-outro");
        fecha();
        aplica(st.pendente, (st.peso != null ? (st.raca ? "raca+peso" : "peso") : "raca") + "+vizinho");
        pd.scrollIntoView({ block: "nearest", behavior: "smooth" });
        return;
      }

      if (e.target.closest("[data-pd-usar]")) {
        var origem = st.peso != null ? (st.raca ? "raca+peso" : "peso") : "raca";
        fecha();
        aplica(st.pendente, origem);
        pd.scrollIntoView({ block: "nearest", behavior: "smooth" });
        return;
      }
    });

    function confirmaPeso(alvo) {
      if (!alvo || !alvo.value) return;
      var v = parseFloat(String(alvo.value).replace(",", "."));
      if (isNaN(v) || v <= 0) return;
      st.peso = v;
      abre("O tamanho do seu cachorro", "", telaVeredito(), peVeredito());
    }
    /* Digitar 12, mudar de ideia e tocar em "20 kg" entregava o veredito de 12 e
       o toque sumia. O blur do campo dispara `change` ANTES do clique, e a
       repintura do corpo destrói o botão no meio do gesto. A bandeira marca que
       um atalho está sendo tocado e faz o `change` se calar — sem setTimeout,
       que aqui seria corrida. */
    pdf.addEventListener("pointerdown", function (e) {
      if (e.target.closest("[data-pd-kg]")) gestoAtalho = true;
    });
    pdf.addEventListener("pointercancel", function () { gestoAtalho = false; });

    pdf.addEventListener("change", function (e) {
      if (gestoAtalho) return;
      confirmaPeso(e.target.closest("#pd-kg"));
    });

    /* O preventDefault vinha ANTES de saber se o alvo era o campo de peso, e
       estava no container inteiro: Enter em qualquer botão da folha era
       engolido e nada acontecia. Só a barra de espaço funcionava. */
    pdf.addEventListener("keydown", function (e) {
      if (e.key !== "Enter") return;
      var campo = e.target.closest("#pd-kg");
      if (!campo) return;                 /* botão: deixa o clique nativo rolar */
      e.preventDefault();
      confirmaPeso(campo);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && st.aberto) fecha(); });

    /* B7: aria-modal declara a folha como modal, mas nada prendia o Tab — o
       foco vazava para a vitrine atrás do véu, que o leitor de tela já não
       anuncia. O ciclo é recalculado a cada tecla porque o corpo é innerHTML
       e os focáveis mudam a cada troca de tela. */
    pdf.addEventListener("keydown", function (e) {
      if (e.key !== "Tab" || !st.aberto) return;
      var focaveis = folha.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focaveis.length) return;
      var primeiro = focaveis[0], ultimo = focaveis[focaveis.length - 1];
      var ativo = document.activeElement;
      if (e.shiftKey && (ativo === primeiro || ativo === folha)) {
        e.preventDefault(); ultimo.focus();
      } else if (!e.shiftKey && ativo === ultimo) {
        e.preventDefault(); primeiro.focus();
      }
    });

    /* a folha herda a skin da barra — as duas nascem "cartela" na marcação */
    pdf.classList.add("pdf--cartela");

    /* ------------------------------------------------------------- arranque */
    function iniciar() {
    grid = document.getElementById("main-collection-product-grid");
    if (!grid) { pd.hidden = true; return; }

    /* B5: a delegação mora em #CollectionProductGrid, que sobrevive ao sort —
       no UL, o listener morria junto com o grid trocado. */
    var casaCliques = document.getElementById("CollectionProductGrid") || grid;
    casaCliques.addEventListener("click", function (e) {
      var b = e.target.closest("[data-pd-avise]");
      if (b) {
        e.preventDefault();
        var handle = b.getAttribute("data-pd-avise");
        var chave = handle + "|" + st.tam;
        b.textContent = "interesse registrado";
        b.disabled = true;
        if (AVISADOS[chave]) return;      /* já contado: não emite de novo */
        AVISADOS[chave] = true;
        try { sessionStorage.setItem(CHAVE_AVISADOS, JSON.stringify(AVISADOS)); } catch (err) {}
        anuncia("Interesse no tamanho " + st.tam + " registrado.");
        ev("pacco_aviseme", { pd_tamanho: st.tam, pd_produto: handle });
        return;
      }

      /* U2: o chip do vizinho no corte do zero-resultado mora dentro do grid,
         então o clique chega por esta mesma delegação que sobrevive ao sort */
      var vz = e.target.closest("[data-pd-vizinho]");
      if (vz) {
        aplica(vz.getAttribute("data-pd-vizinho"), "zero-vizinho");
        pd.scrollIntoView({ block: "nearest", behavior: "smooth" });
        return;
      }

      /* P5: a micro-conversão terminal — clique no card — medida nos DOIS
         braços (com e sem tamanho escolhido). É a comparação usou × não usou
         que decide se o descobridor fica; sem ela a feature vira fé.
         .single-action e .number-showmore são controles do próprio tema que
         vivem dentro do card mas não são "abrir o produto". */
      var a = e.target.closest('a[href*="/products/"]');
      if (a && !e.target.closest(".single-action, .number-showmore")) {
        var li = a.closest("li.product");
        ev("pacco_card_click", {
          pd_tamanho: st.tam || null,
          pd_origem: st.origem || null,
          pd_produto: (li && li.__pdHandle) || null
        });
      }
    });

    /* B6: a barra ja esta VISIVEL desde o Liquid — este bloco so a habilita.
       Por isso nenhuma falha aqui pode mais escondê-la: cada fonte de dado tem
       catch proprio e degrada so a parte que depende dela.
       - racas falhou  -> so a porta "Buscar pela raça" desliga;
       - estoque falhou -> chips ficam inertes (guard `pronto`), o resto vive. */
    /* P3: índice de estoque com cache de sessão (TTL 4 min). Quem volta da
       PDP para a coleção pinta a vitrine JÁ, sem esperar os ~250KB do
       products.json — o fetch segue rodando e só repinta se algo mudou. */
    var CHAVE_ESTOQUE = "pd-estoque:" + COLECAO;
    var cacheJson = null;
    try {
      var cc = JSON.parse(sessionStorage.getItem(CHAVE_ESTOQUE) || "null");
      if (cc && cc.e && (Date.now() - cc.t) < 4 * 60 * 1000) {
        ESTOQUE = cc.e;
        cacheJson = JSON.stringify(cc.e);
      }
    } catch (err) {}

    var vigiado = false;
    function assumir() {
      pronto = Object.keys(ESTOQUE).length > 0;
      mapeiaNovos();
      recupera();
      pintaBarra();
      if (st.tam && pronto) pintaVitrine();
      if (!vigiado) { vigiado = true; vigiaGrid(); }
    }

    if (cacheJson) assumir();

    var D = dados();
    var pRacas = D.racas.catch(function (err) {
      if (window.console && console.warn) console.warn("[pacco-descobridor] raças:", err && err.message);
      return [];
    });
    var pEstoque = D.estoque.then(function (js) { constroiEstoque(js); }).catch(function (err) {
      if (window.console && console.warn) console.warn("[pacco-descobridor] estoque:", err && err.message);
    });

    Promise.all([pRacas, pEstoque]).then(function (res) {
      RACAS = res[0] || [];
      if (!RACAS.length) {
        var portaRaca = pd.querySelector('[data-pd-abrir="raca"]');
        if (portaRaca) portaRaca.disabled = true;
      }
      var frescoJson = null;
      try {
        frescoJson = JSON.stringify(ESTOQUE);
        sessionStorage.setItem(CHAVE_ESTOQUE, JSON.stringify({ t: Date.now(), e: ESTOQUE }));
      } catch (err) {}
      /* pintou do cache e nada mudou -> não repintar (evita flash gratuito) */
      if (!(cacheJson && frescoJson && cacheJson === frescoJson)) assumir();
      ev("pacco_descobridor_visto", { pd_produtos: ITENS.length, pd_retomado: st.tam || null });
    });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", iniciar);
    } else {
      iniciar();
    }
  })();